import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, MailIcon, TruckIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navItems } from '../../data/navigation';
export function Footer() {
  return <footer className="relative overflow-hidden bg-night text-white" data-id="element-284" data-mp="akm3opkav524">
      <div className="shell grid gap-12 pb-10 pt-20 md:grid-cols-12" data-id="element-285" data-mp="5nvr4c7perlg">
        <div className="md:col-span-4" data-id="element-286" data-mp="npsgc30o4tv">
          <Logo tone="light" data-id="element-287" data-mp="orhjkgvarul" />
          <p className="mt-5 max-w-xs leading-relaxed text-white/60" data-id="element-288" data-mp="q2kxj6ehxl6">
            Bureau d’études et atelier de fabrication de décors, sculptures monumentales et scénographies.
          </p>
        </div>

        <div className="md:col-span-3" data-id="element-289" data-mp="3n17um0z8orh1">
          <h2 className="text-sm text-white/45" data-id="element-290" data-mp="3j2rztawx2et2">Atelier</h2>
          <address className="mt-4 space-y-3 not-italic text-white/85" data-id="element-291" data-mp="3j05u7gtl69dh">
            <p className="flex gap-3" data-id="element-292" data-mp="3e2ckwewzkz8z">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-293" data-mp="393t40sx92dnh" />
              <span data-id="element-294" data-mp="3965hotvz61uq">
                12 rue des Forges, ZI Nord
                <br data-id="element-295" data-mp="2kbjtl7vfg5g1" />
                38320 Eybens, France
              </span>
            </p>
            <p className="flex gap-3" data-id="element-296" data-mp="2p4mllbkk36u4">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-297" data-mp="2p5nxtjdb5zdf" />
              <a href="tel:+33476000000" className="hover:text-white" data-id="element-298" data-mp="2babwuu8k7co2">
                +33 4 76 00 00 00
              </a>
            </p>
            <p className="flex gap-3" data-id="element-299" data-mp="340ki4uye6d6v">
              <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-300" data-mp="341lr8tvukply" />
              <a href="mailto:etudes@ateliervolta.fr" className="hover:text-white" data-id="element-301" data-mp="381e4vl03lly6">
                etudes@ateliervolta.fr
              </a>
            </p>
          </address>
        </div>

        <div className="md:col-span-3" data-id="element-302" data-mp="2z0y3qi6tuqwh">
          <h2 className="text-sm text-white/45" data-id="element-303" data-mp="2z43r9szt5kq3">Accès poids lourds</h2>
          <p className="mt-4 flex gap-3 leading-relaxed text-white/85" data-id="element-304" data-mp="1imzlzhbrgtal">
            <TruckIcon className="mt-1 h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-305" data-mp="1nn42368rbm0a" />
            <span data-id="element-306" data-mp="13khnu58ojgwd">Quai de chargement, 2 portes de 4,5 m. Semi-remorques acceptées sur rendez-vous, 6 h – 20 h.</span>
          </p>
        </div>

        <nav aria-label="Pages" className="md:col-span-2" data-id="element-307" data-mp="zkfm5w2y2nh3">
          <h2 className="text-sm text-white/45" data-id="element-308" data-mp="us5uobm6lfcp">Pages</h2>
          <ul className="mt-4 space-y-3" data-id="element-309" data-mp="uqkzcjs1lsds">
            {navItems.map(item => <li key={item.path} data-id="element-310" data-mp="pstaxzqlwoec">
                <Link to={item.path} className="flex items-baseline gap-2 text-white/85 hover:text-white" data-id="element-311" data-mp="pri4tt9ov4k2">
                  {item.label}
                  {item.soon && <span className="font-mono text-[10px] text-white/40" data-id="element-312" data-mp="fudjtwrkxf4u">à venir</span>}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>

      <div className="shell flex flex-col gap-2 border-t border-white/10 py-6 text-sm text-white/45 sm:flex-row sm:justify-between" data-id="element-313" data-mp="6v8n8vzkvvvb">
        <p data-id="element-314" data-mp="2672qq5gs94tk">© 2026 Atelier Volta. Tous droits réservés.</p>
        <p data-id="element-315" data-mp="217ycv1iwyiww">Mentions légales · Confidentialité</p>
      </div>

      <p aria-hidden className="pointer-events-none select-none whitespace-nowrap px-4 pb-2 text-center text-[22vw] font-semibold leading-[0.78] tracking-[-0.06em] text-white/[0.05]" data-id="element-316" data-mp="216nclbooftaj">
        VOLTA
      </p>
    </footer>;
}